import React from "react";
import Card from "components/card";
import { MdClose, MdWarning } from "react-icons/md";

const DeleteModal = ({ isOpen, onClose, onConfirm, itemName }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <Card extra="w-96 bg-white/95 backdrop-blur-sm border border-white/20 shadow-2xl">
        <div className="bg-gradient-to-r from-red-500 to-red-600 p-6 rounded-t-[20px] relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
          <div className="relative z-10 flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="rounded-2xl bg-white/20 backdrop-blur-sm p-3 border border-white/30">
                <MdWarning className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-white">Confirm Delete</h3>
            </div>
            <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30 transition-colors">
              <MdClose className="h-6 w-6" />
            </button>
          </div>
        </div>
        
        <div className="p-6 bg-gradient-to-br from-red-50/50 to-pink-50/50">
          <p className="text-slate-700 mb-6">
            Are you sure you want to delete <strong>"{itemName}"</strong>? This action cannot be undone.
          </p>
          
          <div className="flex space-x-4">
            <button
              onClick={onConfirm}
              className="flex-1 rounded-xl bg-gradient-to-r from-red-500 to-red-600 py-3 px-6 text-white font-semibold hover:from-red-600 hover:to-red-700 transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Delete
            </button>
            <button
              onClick={onClose}
              className="flex-1 rounded-xl bg-slate-100 py-3 px-6 text-slate-700 font-semibold hover:bg-slate-200 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default DeleteModal;